function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin } from 'oskari-ui/util';
import { FILTER_ALL_LAYERS } from '..';
var ViewHandler = /*#__PURE__*/function (_StateHandler) {
  function ViewHandler(instance) {
    var _this;
    _classCallCheck(this, ViewHandler);
    _this = _callSuper(this, ViewHandler);
    _this.instance = instance;
    _this.sandbox = instance.getSandbox();
    _this.layerlistService = _this.sandbox.getService('Oskari.mapframework.service.LayerlistService');
    _this.mapLayerService = _this.sandbox.getService('Oskari.mapframework.service.MapLayerService');
    _this.state = {
      activeFilterId: FILTER_ALL_LAYERS,
      searchText: '',
      filters: _this.getFiltersProvidingResults(_this.initFilters())
    };
    _this.layerlistService.on('Layerlist.Filter.Button.Add', function (_ref) {
      var properties = _ref.properties;
      return _this.addFilter(properties);
    });
    var throttledUpdate = Oskari.util.throttle(_this.refreshActiveFilters.bind(_this), 1000, {
      leading: false
    });
    _this.eventHandlers = {
      'MapLayerEvent': function MapLayerEvent(event) {
        if (['add', 'remove'].includes(event.getOperation())) {
          // heavy op -> throttle
          throttledUpdate();
        }
      }
    };
    Object.getOwnPropertyNames(_this.eventHandlers).forEach(function (p) {
      return _this.sandbox.registerForEventByName(_this, p);
    });
    return _this;
  }

  /**
   * "Module" name for event handling
   */
  _inherits(ViewHandler, _StateHandler);
  return _createClass(ViewHandler, [{
    key: "getName",
    value: function getName() {
      return 'LayerList.FilterHandler';
    }
    /**
    * @method onEvent
    * @param {Oskari.mapframework.event.Event} event a Oskari event object
    * Event is handled forwarded to correct #eventHandlers if found or discarded if not.
    */
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      var handler = this.eventHandlers[event.getName()];
      if (!handler) {
        return;
      }
      return handler.apply(this, [event]);
    }
  }, {
    key: "initFilters",
    value: function initFilters() {
      // Add all layers selection to first
      var all = {
        text: Oskari.getMsg('LayerList', 'filter.all.title'),
        tooltip: Oskari.getMsg('LayerList', 'filter.all.tooltip'),
        id: FILTER_ALL_LAYERS
      };
      return [all].concat(_toConsumableArray(Object.values(this.layerlistService.getLayerlistFilterButtons())));
    }
  }, {
    key: "setActiveFilterId",
    value: function setActiveFilterId(activeFilterId) {
      this.updateState({
        activeFilterId: activeFilterId
      });
    }
  }, {
    key: "setSearchText",
    value: function setSearchText(searchText) {
      this.updateState({
        searchText: searchText
      });
    }
  }, {
    key: "getFiltersProvidingResults",
    value: function getFiltersProvidingResults(filters) {
      var layerService = this.mapLayerService;
      return filters.filter(function (filter) {
        return filter.id === FILTER_ALL_LAYERS || layerService.filterHasLayers(filter.id);
      });
    }
  }, {
    key: "refreshActiveFilters",
    value: function refreshActiveFilters() {
      this.updateState({
        filters: this.getFiltersProvidingResults(this.initFilters())
      });
    }
  }, {
    key: "addFilter",
    value: function addFilter(filter) {
      this.updateState({
        filters: this.getFiltersProvidingResults([].concat(_toConsumableArray(this.state.filters), [filter]))
      });
    }
  }]);
}(StateHandler);
export var FilterHandler = controllerMixin(ViewHandler, ['setActiveFilterId', 'setSearchText']);